function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "main",
  d: "M544.11,831a41.77,41.77,0,1,1,41.77-41.77A41.82,41.82,0,0,1,544.11,831Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M545.86,759.46A.68.68,0,0,0,546,759v-1.76l-1.24,1.61a.7.7,0,0,1-1.1,0l-1.24-1.61V759a.68.68,0,0,0,.15.43l1.09,1.41a.68.68,0,0,0,1.1,0Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M573.9,790.74a.71.71,0,0,0,.42.14h1.76l-1.6-1.24a.71.71,0,0,1,0-1.11l1.61-1.23h-1.76a.76.76,0,0,0-.43.14l-1.42,1.09a.7.7,0,0,0,0,1.1Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M542.56,818.71a.71.71,0,0,0-.14.42v1.76l1.24-1.6a.7.7,0,0,1,1.11,0l1.22,1.61v-1.76a.76.76,0,0,0-.14-.43l-1.09-1.42a.69.69,0,0,0-1.1,0Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M514.65,787.32a.72.72,0,0,0-.42-.15h-1.76l1.6,1.25a.69.69,0,0,1,0,1.1l-1.61,1.23h1.76a.66.66,0,0,0,.42-.15l1.43-1.08a.7.7,0,0,0,0-1.1Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M524.44,767a.67.67,0,0,0-.2-.4L523,765.36l.26,2a.69.69,0,0,1-.78.78l-2-.26,1.25,1.24a.7.7,0,0,0,.4.2l1.77.23a.69.69,0,0,0,.78-.78Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M566.38,769.3a.74.74,0,0,0,.41-.19l1.24-1.25-2,.26a.7.7,0,0,1-.78-.78l.27-2-1.24,1.24a.69.69,0,0,0-.2.41l-.24,1.77a.7.7,0,0,0,.78.78Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M564,811.24a.75.75,0,0,0,.19.4l1.24,1.25-.25-2a.7.7,0,0,1,.78-.78l2,.28-1.24-1.25a.7.7,0,0,0-.4-.2l-1.77-.24a.7.7,0,0,0-.79.78Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M522.07,808.78a.7.7,0,0,0-.4.2l-1.25,1.23,2-.25a.7.7,0,0,1,.78.79l-.28,2,1.25-1.23a.7.7,0,0,0,.2-.4l.25-1.77a.7.7,0,0,0-.78-.79Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M572.3,779.35a.77.77,0,0,0,.45,0l1.63-.67-2-.53a.7.7,0,0,1-.42-1l1-1.75-1.63.67a.74.74,0,0,0-.34.29l-.9,1.55a.7.7,0,0,0,.42,1Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M554,817.14a.67.67,0,0,0,0,.44l.66,1.63.54-2a.69.69,0,0,1,1-.41l1.75,1-.66-1.63a.71.71,0,0,0-.3-.34l-1.54-.9a.69.69,0,0,0-1,.41Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M516.2,798.71a.7.7,0,0,0-.45,0l-1.63.65,2,.55a.69.69,0,0,1,.42,1l-1,1.75,1.63-.66a.65.65,0,0,0,.34-.29l.91-1.55a.69.69,0,0,0-.41-1Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M534.7,761a.69.69,0,0,0,0-.45l-.66-1.63-.54,2a.7.7,0,0,1-1,.41l-1.74-1,.65,1.63a.63.63,0,0,0,.3.34l1.53.91a.69.69,0,0,0,1-.41Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M557.21,762.38a.71.71,0,0,0,.3-.34l.68-1.62-1.76,1a.69.69,0,0,1-1-.42l-.52-2-.68,1.62a.69.69,0,0,0,0,.45l.46,1.73a.69.69,0,0,0,1,.42Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M571,802.07a.68.68,0,0,0,.33.3l1.63.69-1-1.77a.68.68,0,0,1,.43-1l2-.52-1.63-.68a.66.66,0,0,0-.44,0l-1.73.45a.69.69,0,0,0-.43,1Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M531.23,815.74a.64.64,0,0,0-.3.33l-.69,1.62,1.77-1a.69.69,0,0,1,1,.44l.51,2,.69-1.62a.69.69,0,0,0,0-.45l-.45-1.73a.69.69,0,0,0-1-.43Z",
  transform: "translate(-502.34 -747.45)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "secondary",
  d: "M517.64,776a.64.64,0,0,0-.33-.3l-1.62-.69,1,1.76a.71.71,0,0,1-.44,1l-2,.5,1.62.7a.69.69,0,0,0,.45,0l1.73-.45a.69.69,0,0,0,.43-1Z",
  transform: "translate(-502.34 -747.45)"
});

function SvgRotaryCenter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.54 83.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotaryCenter);
export default __webpack_public_path__ + "static/media/rotary-center.6c248a15.svg";
export { ForwardRef as ReactComponent };